import {css, styled} from "styled-components";
import {Observer} from "mobx-react";
import {useAppStore} from "../../StateManager";
import {colorPalette} from "./styles/colorPalette";
import {FlexCenterStyle, radius} from "./styles/styles";
import {LoaderStyled} from "./loader/LoaderV5";
import {RunReportStyled} from "./modules/report/create/wizard/run/RunReportPage.style";

export const Main = () => {
	const appState = useAppStore((state) => state.appState);
	const {selectedMenu} = appState;
	const Component = appState.app.navigation.getComponent(selectedMenu);

	return (
		<Observer>
			{() => {
				const areThereAnyOverlayedItems = appState.app.overlayedDetailedItems.length > 0;

				const onClick = () => {
					if (areThereAnyOverlayedItems) {
						appState.app.overlayedDetailedItems = [];
					}
				};

				return (
					<MainStyled
						className="appContent"
						$isBlurred={areThereAnyOverlayedItems ? (appState.app.overlayedDetailedItems[0]?.isMainBlurred ?? false) : false}
						onClick={onClick}
					>
						<Component spaceViewRenderer={appState.app.spaceViewRenderer} />
					</MainStyled>
				);
			}}
		</Observer>
	);
};

const MainStyled = styled.main<{$isBlurred: boolean}>`
	${FlexCenterStyle}
	align-items: normal;
	background-color: ${colorPalette.white};
	flex: 1;
	min-height: 0;

	${(props) => {
		if (props.$isBlurred) {
			return css`
				&::after {
					content: "";
					background: #00000082;
					position: absolute;
					width: 100%;
					height: 100%;
					z-index: 10;
				}
			`;
		}
	}}

	.sidePanelContainer {
		background-color: ${colorPalette.white};
		z-index: 1;
		min-height: 0;
		overflow-x: auto;
	}

	.Splitter {
		height: min-content;
		overflow: hidden;
		flex: 1;
		min-height: 0;

		.dragger {
			background-color: ${colorPalette.gray.c200Light};
			z-index: 2;
			position: relative;
			cursor: col-resize;

			.handler {
				background-color: ${colorPalette.blueGray.c200Light};
				color: ${colorPalette.primary.c500Primary};
				position: absolute;
				transform: translateY(-50%);
				top: 50%;
				border-top-left-radius: ${radius.sm};
				border-bottom-left-radius: ${radius.sm};
				cursor: pointer;
			}
		}
	}

	.SidePanel {
		.buttons {
			display: none;
		}
	}

	${LoaderStyled} {
		width: 100%;

		& + ${RunReportStyled} {
			display: none;
		}
	}
`;
